import React, { useRef } from "react";
interface StyleInterface {
    customStyles?: string;
    btnText?: string;
    titleContent: string;
    isIconBtn?: boolean;
    link?: string;
    isMobile?: boolean;
}

const TopNavBlock: React.FC<StyleInterface> = ({ customStyles, btnText, titleContent, link, isMobile = false }) => {
    const topBlk = useRef<HTMLDivElement>(null);

    return (
        <div ref={topBlk} className={`above-navbar px-2 z-10 w-full bg-green-500 py-4 ${customStyles}`} style={{ background: "linear-gradient(#000, #000)" }}>
            <div className="flex justify-center items-center lg:space-y-0 space-y-2">
                {isMobile ? (
                    <p className="pt-1 text-sm font-semibold text-center text-white">
                        <span className="px-2"> {titleContent}</span>
                        {btnText && (
                            <a
                                className="pl-2 px-2 text-sm font-semibold rounded-sm whitespace-nowrap hover:no-underline cursor-pointer text-black bg-white hover:bg-blue-200"
                                href={link}
                                target="_blank"
                                rel="noreferrer"
                                id="banner-action_btn"
                            >
                                {btnText}
                            </a>
                        )}
                    </p>
                ) : (
                    <div className="lg:block hidden">
                        <div className="max-w-6xl flex items-center justify-center gap-5 w-full">
                            <p className="text-lg font-semibold text-center text-white">{titleContent}</p>
                            {btnText && (
                                <a
                                    className="text-base text-center font-semibold cursor-pointer text-black hover:no-underline px-3 py-1 rounded-md whitespace-nowrap bg-white hover:bg-blue-200"
                                    href={link}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {btnText}
                                </a>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TopNavBlock;
